import Header from 'components/headers/easyPay'
import InitTransaction from 'modules/easyPay/init'
import InitGatewayPayment from 'modules/easyPay/init/indexGatewayPayment'
import React from 'react'

export default function InitPage() {
    return (
        <div className=" h-screen relative">
            <Header title="پرداخت آسان" />
            <InitTransaction />
        </div>
    )
}
